import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { columnsB0401 } from 'constants/reportColumns';
import { BProps, DataTypeB0401 } from 'store/ducks/Reportings/types';

const B0401: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeB0401[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };
    try {
      const fetchedData =
        await reportingOp.fetchContractualArrangementsICTUse(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            arrangement_reference_number: dataItem.arrangement_reference_number,
            branch_identification_code: dataItem.branch_identification_code,
            lei_entity_making_use_ICT_service:
              dataItem.lei_entity_making_use_ICT_service,
            nature_of_entity: dataItem.nature_of_entity,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  return (
    <>
      <Table
        columns={columnsB0401}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0401;
